module.exports = __webpack_public_path__ + "static/media/Ikeja.5ce72c85.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Ikeja.svg
// module id = 425
// module chunks = 25